import {Box, Button, Card, CardActions, CardContent, Stack, Typography} from '@mui/material';
import {PriceInterval, Product, UserAccount} from '../../__generated__/resolvers-types';
import {formatCurrency} from '../../util/formatCurrency';

interface PricingPlansCardProps {
  product: Product;
  user: UserAccount | undefined | null;
  onSelectPlan: (planName: string) => void;
  isMonthly: boolean;
}

export default function PricingPlansCard({product, user, onSelectPlan, isMonthly}: PricingPlansCardProps) {
  const yearlyPrice = product.prices.find((price) => price.interval === PriceInterval.year);
  const monthlyPrice = product.prices.find((price) => price.interval === PriceInterval.month);
  const price = isMonthly ? monthlyPrice : yearlyPrice;

  if (!price) {
    return null;
  }

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: product.name === 'Professional' ? '2px solid #1976d2' : 'none',
      }}
    >
      {/* {product.name === mostPopularProduct && (
        <Box
          sx={{
            position: 'relative',
            top: 0,
            right: 0,
            bgcolor: 'primary.main',
            color: 'white',
            px: 2,
            py: 1,
            borderRadius: '0 0 0 8px',
          }}
        >
          Most Popular
        </Box>
      )} */}
      <CardContent sx={{flexGrow: 1}}>
        <Typography variant="h5" component="h3" gutterBottom>
          {product.name}
        </Typography>

        <Typography variant="h3" component="div" gutterBottom>
          {formatCurrency(price.currency, price.unitAmount / 100)}
          <Typography component="span" variant="h6" color="text.secondary">
            /{isMonthly ? 'month' : 'year'}
          </Typography>
        </Typography>

        {yearlyPrice && monthlyPrice && (
          <Typography variant="body1" color="text.secondary" gutterBottom>
            Save {formatCurrency(monthlyPrice.currency, (monthlyPrice.unitAmount * 12 - yearlyPrice.unitAmount) / 100)}{' '}
            with yearly billing
          </Typography>
        )}

        <Box sx={{my: 2}}>
          {product.description && (
            <Typography variant="body1" sx={{mb: 1}}>
              {product.description}
            </Typography>
          )}
        </Box>

        {product.features.length ? (
          <Stack>
            {product.features.map((feature) => (
              <Typography variant="body1" key={feature}>
                {feature}
              </Typography>
            ))}
          </Stack>
        ) : null}
      </CardContent>
      <CardActions sx={{mt: 'auto', pt: 2}}>
        <Button
          fullWidth
          variant={product.name === 'Professional' ? 'contained' : 'outlined'}
          onClick={() => onSelectPlan(product.name)}
          // disabled={!user}
          sx={{mt: 2}}
        >
          {user ? 'Select Plan' : 'Sign Up to Get Started'}
        </Button>
      </CardActions>
    </Card>
  );
}
